import React from "react";
import "./StarIcon.css";

const icons = {
  apple: (
    <>
      <path d="M12 7c-4.2 0-6.2 2.6-5.7 6.3.4 3.4 2.6 6.2 4.4 5.4.8-.4 1.7-.4 2.6 0 1.8.8 4-2 4.4-5.4C18.2 9.6 16.2 7 12 7Z" />
      <path d="M12 7c.1-2.1 1.3-3.4 3.4-3.9" />
      <path d="M11.8 6.9c-1-1.8-2.4-2.5-4.1-2.2" />
    </>
  ),
  award: (
    <>
      <circle cx="12" cy="8.2" r="4.1" />
      <path d="m9.2 11.4-1.4 7.1 4.2-2.2 4.2 2.2-1.4-7.1" />
      <path d="m10.4 8.3 1.1 1.1 2.2-2.4" />
    </>
  ),
  bacon: (
    <>
      <path d="M7.2 4.5c-1.5 2.1 1.4 3.6-.1 5.7-1.4 2.1 1.6 3.8 0 6.4" />
      <path d="M12 4.2c-1.5 2.2 1.3 3.8-.2 6-1.4 2.1 1.5 3.7.1 6.5" />
      <path d="M16.8 4.5c-1.5 2.1 1.4 3.6-.1 5.7-1.4 2.1 1.6 3.8 0 6.4" />
    </>
  ),
  basket: (
    <>
      <path d="M6.5 10.2 8.7 5m8.8 5.2L15.3 5" />
      <path d="M5.2 10.2h13.6l-1.4 8.1H6.6l-1.4-8.1Z" />
      <path d="M8.1 13.1v3M12 13.1v3M15.9 13.1v3" />
    </>
  ),
  beer: (
    <>
      <path d="M7.2 8.4h8.6v10.2H7.2z" />
      <path d="M15.8 10.4h1.5c1 0 1.8.8 1.8 1.8v2.3c0 1-.8 1.8-1.8 1.8h-1.5" />
      <path d="M8.8 8.4c-.8-.8-.4-2 .8-2 1.3 0 1.1-1.6 2.4-1.6s1 1.6 2.5 1.6c1.2 0 1.5 1.2.7 2" />
      <path d="M10 11.4v4.4M13 11.4v4.4" />
    </>
  ),
  birthdayCake: (
    <>
      <path d="M6 10.2h12v8H6z" />
      <path d="M6 13.2c1.4 1 2.6 1 4 0 1.4-1 2.6-1 4 0 1.4 1 2.6 1 4 0" />
      <path d="M9 10.2V7M12 10.2V7M15 10.2V7" />
      <path d="M9 5.1c.6.6.6 1.1 0 1.7-.6-.6-.6-1.1 0-1.7ZM12 5.1c.6.6.6 1.1 0 1.7-.6-.6-.6-1.1 0-1.7ZM15 5.1c.6.6.6 1.1 0 1.7-.6-.6-.6-1.1 0-1.7Z" />
    </>
  ),
  bolt: <path d="m13.4 3-6 10h4l-.8 8 6-10h-4l.8-8Z" />,
  bottle: (
    <>
      <path d="M10.3 4.2h3.4v4.1c0 .9.5 1.5 1.2 2.2.7.7 1.1 1.6 1.1 2.7v5.2c0 .9-.7 1.6-1.6 1.6H9.6c-.9 0-1.6-.7-1.6-1.6v-5.2c0-1.1.4-2 1.1-2.7.7-.7 1.2-1.3 1.2-2.2V4.2Z" />
      <path d="M9.7 7.7h4.6M8 14h8" />
    </>
  ),
  cake: (
    <>
      <path d="M5.5 10.6h13v7.2h-13z" />
      <path d="M5.5 13.2c1.5 1 3 1 4.5 0s3-1 4.5 0 2.5 1 4 0" />
      <path d="M8 10.6V8.2h8v2.4" />
    </>
  ),
  calendar: (
    <>
      <rect x="5" y="5.7" width="14" height="13" rx="1.8" />
      <path d="M8.2 3.5v4M15.8 3.5v4M5 9.4h14" />
      <path d="M8.3 12.4h2.2M13.5 12.4h2.2M8.3 15.5h2.2M13.5 15.5h2.2" />
    </>
  ),
  carrot: (
    <>
      <path d="m6 18 9.4-9.4 3 3L9 21 6 18Z" />
      <path d="M15 8.5c-1.2-2.1-.7-3.7 1.4-4.9.2 2-.3 3.6-1.4 4.9Z" />
      <path d="M16.4 9.6c1-2.3 2.5-3.1 4.6-2.2-1 1.7-2.5 2.4-4.6 2.2Z" />
      <path d="M8.6 15.4h3.1M11.1 12.9h3.1" />
    </>
  ),
  check: <path d="m5.2 12.4 4.3 4.1 9.3-9.1" />,
  cheese: (
    <>
      <path d="M4.5 16.7 18 7.2v9.5H4.5Z" />
      <path d="M4.5 16.7v2.4H18v-2.4" />
      <circle cx="13.3" cy="14.1" r="1" />
      <circle cx="16" cy="11.2" r=".8" />
    </>
  ),
  chevronDown: <path d="m6 9 6 6 6-6" />,
  chevronRight: <path d="m9 6 6 6-6 6" />,
  clipboardCheck: (
    <>
      <path d="M8.5 5.7h-2a1.8 1.8 0 0 0-1.8 1.8v10.8A1.8 1.8 0 0 0 6.5 20h11a1.8 1.8 0 0 0 1.8-1.8V7.5a1.8 1.8 0 0 0-1.8-1.8h-2" />
      <path d="M8.5 6.8V5.2h7v1.6a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1Z" />
      <path d="m8.3 13.4 2.5 2.3 5-5" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.4" />
      <path d="M12 7.5v5l3.4 2" />
    </>
  ),
  close: (
    <>
      <path d="M6.5 6.5 17.5 17.5" />
      <path d="M17.5 6.5 6.5 17.5" />
    </>
  ),
  coffee: (
    <>
      <path d="M7 10.2h9v5.2a3.2 3.2 0 0 1-3.2 3.2H10.2A3.2 3.2 0 0 1 7 15.4v-5.2Z" />
      <path d="M16 11.4h1.5a1.9 1.9 0 0 1 0 3.8H16" />
      <path d="M9.3 6.1c-.8.8-.8 1.6 0 2.4M12 5.4c-.9 1-.9 1.9 0 2.8M14.7 6.1c-.8.8-.8 1.6 0 2.4" />
    </>
  ),
  cookie: (
    <>
      <path d="M18.7 11.2a7.1 7.1 0 1 1-6.4-6.4 3.2 3.2 0 0 0 3 4.5 3.4 3.4 0 0 0 3.4 1.9Z" />
      <circle cx="9.2" cy="10.5" r=".8" />
      <circle cx="12" cy="15" r=".8" />
      <circle cx="14.6" cy="12.2" r=".7" />
    </>
  ),
  copy: (
    <>
      <rect x="8.2" y="7.2" width="10" height="12" rx="1.6" />
      <path d="M5.8 16.8H5.4A1.4 1.4 0 0 1 4 15.4v-10A1.4 1.4 0 0 1 5.4 4h8.2A1.4 1.4 0 0 1 15 5.4v.3" />
    </>
  ),
  cut: (
    <>
      <path d="m5 18.5 12.8-12.8 1.1 1.1L8 19.6a2.1 2.1 0 0 1-3-1.1Z" />
      <path d="M13.4 7.8 16.2 5" />
    </>
  ),
  dollar: (
    <>
      <path d="M12 4.2v15.6" />
      <path d="M15.8 7.2c-1.2-1-4.7-1.4-5.8.3-1.6 2.5 5.8 2.5 4.9 5.8-.6 2.3-4.8 2.4-6.7.8" />
    </>
  ),
  drumstick: (
    <>
      <path d="M16.7 6.3c2 2 1.7 5.3-.7 7.7-2 2-5.4 2.3-7.3.6-1.7-1.5-1.3-4.8.8-6.9 2.4-2.3 5.2-3.4 7.2-1.4Z" />
      <path d="m8.5 14.4-2 2" />
      <path d="M4.6 17.1c-.8-.8-.7-2 .1-2.8.9-.9 1.4.3 2.2 1.1s2 1.3 1.1 2.2c-.8.8-2 .9-2.8.1l-.6-.6Z" />
    </>
  ),
  egg: <ellipse cx="12" cy="12.2" rx="5.2" ry="7.4" />,
  facebook: (
    <>
      <circle cx="12" cy="12" r="8.4" />
      <path d="M13.5 8.2h-1.1c-1 0-1.5.6-1.5 1.6v1.3H9.4v2.3h1.5v4.4h2.4v-4.4h1.7l.3-2.3h-2V10c0-.4.2-.6.6-.6h1.1V8.2h-1.5Z" />
    </>
  ),
  fire: (
    <path d="M12.6 20c3.2-.4 5.2-2.7 5.2-5.8 0-2.4-1.3-4.3-3.4-6.3.1 2.1-.8 3-2.1 3.7.3-3.1-1.4-5.3-4-7.6.4 3-1.6 4.9-2.1 7.3-.8 3.8 1.7 8 6.4 8.7Z" />
  ),
  fish: (
    <>
      <path d="M5 12c3.2-4.4 8.2-4.4 12 0-3.8 4.4-8.8 4.4-12 0Z" />
      <path d="m17 12 3-3v6l-3-3Z" />
      <circle cx="9" cy="11" r=".6" />
    </>
  ),
  glass: (
    <>
      <path d="M7.2 5h9.6l-1.1 14H8.3L7.2 5Z" />
      <path d="M8 9.3h8" />
      <path d="M10 12.3h4" />
    </>
  ),
  hotdog: (
    <>
      <path d="M5 14.5c2.7 3.6 11.3 3.6 14 0" />
      <path d="M5 9.5c2.7-3.6 11.3-3.6 14 0" />
      <path d="M7.2 12c2-2.1 7.6-2.1 9.6 0-2 2.1-7.6 2.1-9.6 0Z" />
      <path d="M8.5 12.1c1.2.5 2.1-.6 3.2 0 1.1.6 2-.6 3.4 0" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.4" />
      <path d="M12 10.8v5.2" />
      <path d="M12 7.7h.01" />
    </>
  ),
  instagram: (
    <>
      <rect x="5" y="5" width="14" height="14" rx="4" />
      <circle cx="12" cy="12" r="3.4" />
      <circle cx="16" cy="8" r=".6" />
    </>
  ),
  leaf: (
    <>
      <path d="M5 14.5C7.4 7 13.3 4.4 20 5.2c-.8 6.8-4.3 11.5-11.2 11.5" />
      <path d="M5 20c3.5-5.8 7.2-8.9 12-11" />
    </>
  ),
  lock: (
    <>
      <rect x="5.8" y="10" width="12.4" height="9" rx="1.8" />
      <path d="M8.5 10V7.7a3.5 3.5 0 0 1 7 0V10" />
      <path d="M12 13.4v2.4" />
    </>
  ),
  mail: (
    <>
      <rect x="4.5" y="6.5" width="15" height="11" rx="1.8" />
      <path d="m5.2 7.4 6.8 5.2 6.8-5.2" />
    </>
  ),
  mapPin: (
    <>
      <path d="M18 10.2c0 4.6-6 10.1-6 10.1s-6-5.5-6-10.1a6 6 0 1 1 12 0Z" />
      <circle cx="12" cy="10.1" r="2" />
    </>
  ),
  mug: (
    <>
      <path d="M6.5 9.8h9v5.4a3.4 3.4 0 0 1-3.4 3.4H9.9a3.4 3.4 0 0 1-3.4-3.4V9.8Z" />
      <path d="M15.5 11h1.8a2.2 2.2 0 0 1 0 4.4h-1.8" />
      <path d="M9 5.2c-.8.8-.8 1.6 0 2.4M12 4.8c-.9.9-.9 1.8 0 2.7M15 5.2c-.8.8-.8 1.6 0 2.4" />
    </>
  ),
  phone: (
    <path d="M8.1 4.9 6 6.7c-.8.7-.7 2.4.2 4.4 1.1 2.5 3.2 4.6 5.7 5.7 2 .9 3.7 1 4.4.2l1.8-2.1-3.5-2.8-1.5 1.5c-1.8-.9-3.1-2.2-3.9-3.9l1.5-1.5-2.6-3.3Z" />
  ),
  plus: (
    <>
      <path d="M12 5.5v13" />
      <path d="M5.5 12h13" />
    </>
  ),
  sandwich: (
    <>
      <path d="M5 10c1.8-3.5 12.2-3.5 14 0v7.2H5V10Z" />
      <path d="M5 12.2h14" />
      <path d="M7.5 14.8h3.2M13.3 14.8h3.2" />
      <path d="M8 9.4h.01M12 8.8h.01M16 9.4h.01" />
    </>
  ),
  save: (
    <>
      <path d="M5.2 4.8h11.4l2.2 2.2v12.2H5.2V4.8Z" />
      <path d="M8 4.8v5.1h7.2V4.8" />
      <path d="M8.2 19.2v-5.4h7.6v5.4" />
    </>
  ),
  scroll: (
    <>
      <path d="M8 5.2h8.6c1.2 0 2.1 1 2.1 2.1v10.5c0-1.2-1-2.1-2.1-2.1H8V5.2Z" />
      <path d="M8 15.7H6.6a2.1 2.1 0 1 0 0 4.2h10" />
      <path d="M10.4 8.7h5.5M10.4 12h5.5" />
    </>
  ),
  signOut: (
    <>
      <path d="M9.5 5.2H6.2v13.6h3.3" />
      <path d="M12 8.3 15.7 12 12 15.7" />
      <path d="M15.4 12H8.8" />
    </>
  ),
  star: (
    <path
      d="m12 4.2 2.1 4.5 4.9.6-3.6 3.3.9 4.8-4.3-2.5-4.3 2.5.9-4.8L5 9.3l4.9-.6L12 4.2Z"
      fill="currentColor"
    />
  ),
  truck: (
    <>
      <path d="M4.5 7.2h9.2v8.2H4.5z" />
      <path d="M13.7 10h3.2l2.6 2.8v2.6h-5.8V10Z" />
      <circle cx="8" cy="17.1" r="1.6" />
      <circle cx="16.8" cy="17.1" r="1.6" />
    </>
  ),
  twitter: (
    <>
      <path d="M19 6.8c-.7.3-1.4.5-2.2.6A3.2 3.2 0 0 0 11.3 10v.7A8.2 8.2 0 0 1 5.2 7.6s-2.7 6.1 3.8 8.8a8.8 8.8 0 0 1-4.6 1.2c6.5 3.8 13.3 0 13.3-7.5v-.4c.6-.5 1-1 1.3-1.7Z" />
    </>
  ),
  undo: (
    <>
      <path d="M8 8.2H4.5V4.7" />
      <path d="M4.8 8.2a7 7 0 1 1 2.1 7.4" />
    </>
  ),
  warning: (
    <>
      <path d="M12 4.3 21 19H3L12 4.3Z" />
      <path d="M12 9.4v4.3" />
      <path d="M12 16.8h.01" />
    </>
  ),
  wineGlass: (
    <>
      <path d="M8 5h8l-.7 5.6a3.3 3.3 0 0 1-6.6 0L8 5Z" />
      <path d="M9 8.8h6M12 14v5M9 19h6" />
    </>
  ),
};

const resolveIconName = (name) => {
  if (typeof name !== "string") return "sandwich";
  return name;
};

const StarIcon = ({
  name,
  title,
  size = "1em",
  strokeWidth = 2,
  className = "",
  spin = false,
  ...props
}) => {
  const iconName = resolveIconName(name);
  const icon = icons[iconName] || icons.sandwich;
  const classes = ["star-icon", spin ? "star-icon--spin" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={classes}
      aria-hidden={title ? undefined : "true"}
      role={title ? "img" : undefined}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...props}
    >
      {title && <title>{title}</title>}
      {icon}
    </svg>
  );
};

export default React.memo(StarIcon);
